// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepForwardOutlinedSvg from "@fishx/icons-svg/es/asn/StepForwardOutlined";
import FishxIcon from '../components/FishxIcon';

var StepForwardOutlined = function StepForwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardOutlinedSvg
  }));
};

StepForwardOutlined.displayName = 'StepForwardOutlined';
export default React.forwardRef(StepForwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StepForwardOutlined.js
// module id = 4191
// module chunks = 0